import { render, staticRenderFns } from "./PageStartDelivery.vue?vue&type=template&id=2351e702&scoped=true&"
import script from "./PageStartDelivery.vue?vue&type=script&lang=ts&"
export * from "./PageStartDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./PageStartDelivery.vue?vue&type=style&index=0&id=2351e702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351e702",
  null
  
)

export default component.exports